import { defineMessages } from 'utils/intl';

export default defineMessages({
  leasing: 'Leasing dla firm',
  loan: 'Raty dla firm',
  deferred: 'Płatność odroczona',
  initialFee: 'Wpłata początkowa',
  residualFee: 'Wysokość wykupu',
  initialFeePrice: 'Wpłata początkowa: {price}',
  residualFeePrice: 'Wysokość wykupu: {price}',
  monthlyInstallment: 'Twoja miesięczna rata:',
  numberOfMonths: 'Przez ile miesięcy chcesz spłacać?',
  info: 'Kalkulacja nie stanowi oferty w rozumieniu kodeksu cywilnego i nie jest jednoznaczna z rezerwacją produktów.',
});
